/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 *  @module GslbModule
 */

/**
 * Ajs dependency token for GeoProfile Item.
 */
export const GSLB_GEODB_PROFILE_ITEM_TOKEN = 'GslbGeoDbProfileItem';

/**
 * Ajs dependency token for GeoProfile Collection.
 */
export const GSLB_GEODB_PROFILE_COLLECTION_TOKEN = 'GslbGeoDbProfileCollection';

export const GSLB_SERVICE_ITEM_TOKEN = 'GSLBService';
